import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from "@/locales/en/translation.json";
import esTranslation from "@/locales/es/translation.json";

export const supportedLanguages = ["es", "en"] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const languageStorageKey = "conversa-language";

export function normalizeLanguage(language?: string | null): SupportedLanguage {
  const normalized = language?.toLowerCase().split("-")[0];
  return supportedLanguages.includes(normalized as SupportedLanguage)
    ? (normalized as SupportedLanguage)
    : "es";
}

export function getInitialLanguage(): SupportedLanguage {
  if (typeof window === "undefined") return "es";

  const storedLanguage = window.localStorage.getItem(languageStorageKey);
  if (storedLanguage) return normalizeLanguage(storedLanguage);

  return normalizeLanguage(window.navigator.language);
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: esTranslation },
      en: { translation: enTranslation },
    },
    lng: getInitialLanguage(),
    fallbackLng: "es",
    interpolation: {
      escapeValue: false,
    },
    returnEmptyString: false,
  });

i18n.on("languageChanged", (language) => {
  const normalizedLanguage = normalizeLanguage(language);
  if (typeof document !== "undefined") {
    document.documentElement.lang = normalizedLanguage;
  }
  if (typeof window !== "undefined") {
    window.localStorage.setItem(languageStorageKey, normalizedLanguage);
  }
});

if (typeof document !== "undefined") {
  document.documentElement.lang = normalizeLanguage(i18n.language);
}

export default i18n;
